import { TParcelItemsUA } from "@/types/parcel.types";
import * as Yup from "yup";

//@ts-ignore
export const parcelDetailsSchemaUa: Yup.ObjectSchema<TParcelDetailsUA> =
  Yup.object().shape({
    country: Yup.number().required("validations_country_required"),
    dontRemember: Yup.boolean(),
    trackingNumber: Yup.string()
      .min(9, "invalid_tracking_number_uk")
      .max(40, "invalid_tracking_number_uk")
      .matches(/^[a-zA-Z0-9-]*$/, "invalid_tracking_number_uk")
      .when("dontRemember", {
        is: false,
        then: (schema) =>
          schema.required("validations_tracking_number_required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    deliveryFromFcountryTypeId: Yup.string().required(
      "validations_transportation_type_required",
    ),
    customAddressId: Yup.object().shape({
      id: Yup.number(),
      mainText: Yup.string(),
    }),
    defaultAddressDeliveryTypeId: Yup.number(),
    departIdPreDelivery: Yup.object().when("defaultAddressDeliveryTypeId", {
      is: 2,
      then: (schema) =>
        schema
          .required("validations_select_warehouse")
          .test(
            "defaultAddressDeliveryTypeId",
            "validations_select_warehouse",
            (value: { id: number | string; mainText: string }) =>
              !!value && (!!value.id || value.id === 0) && !!value.mainText,
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    addressIdPreDelivery: Yup.object().when("defaultAddressDeliveryTypeId", {
      is: 1,
      then: (schema) =>
        schema
          .required("validations_select_delivery_address")
          .test(
            "defaultAddressDeliveryTypeId",
            "validations_select_delivery_address",
            (value: { id: number | string; mainText: string }) =>
              !!value && (!!value.id || value.id === 0) && !!value.mainText,
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    shop: Yup.mixed().required("validations_select_shop"),
  });

//@ts-ignore
export const parcelItemsSchemaUa: Yup.ObjectSchema<TParcelItemsUA> =
  Yup.object().shape({
    products: Yup.array()
      .of(
        Yup.object()
          .shape({
            productPriceUsd: Yup.string()
              .required("validations_product_price_required")
              .test(
                "is-greater-than-zero",
                "validation_greater_than_zero",
                (value: unknown) => {
                  if (typeof value !== "string" && typeof value !== "number")
                    return false;
                  const num = Number(value);
                  return num > 0;
                },
              ),
            productAmount: Yup.mixed()
              .test(
                "is-string-or-number",
                "validations_product_quantity_required",
                (value) =>
                  typeof value === "string" || typeof value === "number",
              )
              .test(
                "is-greater-than-zero",
                "validation_greater_than_zero",
                (value: unknown) => {
                  if (typeof value !== "string" && typeof value !== "number")
                    return false;
                  const num = Number(value);
                  return num > 0;
                },
              )
              .required("validations_product_quantity_required"),
            productCategoryId: Yup.object({
              id: Yup.number().required("validations_category_required"),
              mainText: Yup.string(),
            }).required("validations_category_required"),
            productDescription: Yup.string().required(
              "validations_description_required",
            ),
            productConditionId: Yup.mixed().notRequired(),
            productBrandName: Yup.string().required(
              "validations_field_required",
            ),
            productModelName: Yup.string().notRequired(),
          })
          .required("validations_product_details_required"),
      )
      .default([])
      .required("validations_products_required"),
    productPriceUsd: Yup.string()
      .required("validations_product_price_required")
      .test(
        "is-greater-than-zero",
        "validation_greater_than_zero",
        (value: unknown) => {
          if (typeof value !== "string" && typeof value !== "number")
            return false;
          const num = Number(value);
          return num > 0;
        },
      ),
    productAmount: Yup.mixed()
      .test(
        "is-string-or-number",
        "validations_product_quantity_required",
        (value) => typeof value === "string" || typeof value === "number",
      )
      .test(
        "is-greater-than-zero",
        "validation_greater_than_zero",
        (value: unknown) => {
          if (typeof value !== "string" && typeof value !== "number")
            return false;
          const num = Number(value);
          return num > 0;
        },
      )
      .required("validations_product_quantity_required"),
    productCategoryId: Yup.object({
      id: Yup.number().required("validations_category_required"),
      mainText: Yup.string(),
    }).required("validations_category_required"),
    productConditionId: Yup.mixed().notRequired(),
    productBrandName: Yup.string().required("validations_field_required"),
    productModelName: Yup.string().notRequired(),
    productDescription: Yup.string().required(
      "validations_description_required",
    ),
  });
